import axios from "axios";

// --- Histórico de informes (process-logs) ---
// Llamadas axios crudas: devuelven el `data` de la respuesta tal cual. La validación
// (success/error) y la transformación viven en services/history-reports.service.js.
const PROCESS_LOGS = '/api/v2/process-logs';

export async function fetchProcessLogs(params) {
  const { data } = await axios.get(PROCESS_LOGS, { params });
  return data;
}

export async function fetchProcessLog(id) {
  const { data } = await axios.get(`${PROCESS_LOGS}/${id}`);
  return data;
}

export async function deleteProcessLog(id) {
  const { data } = await axios.delete(`${PROCESS_LOGS}/${id}/delete`);
  return data;
}

export async function downloadProcessLog(id) {
  const { data } = await axios.post(`${PROCESS_LOGS}/${id}/download`);
  return data;
}

// --- Generación del informe detallado (report-generate-form) ---
// Llamadas axios crudas: devuelven `data` (o la respuesta en la subida Vapor). La lógica
// (filtros, armado de infoTabs, etc.) vive en services/helpers.

export async function fetchActivities(projectId) {
  const { data } = await axios.get('/api/v2/activities', { params: { p: projectId, per_page: 999 } });
  return data;
}

export async function fetchSubactivities(activityId) {
  const { data } = await axios.get(`/api/v2/activity/${activityId}/subactivities`);
  return data;
}

export async function fetchActivityDocuments(activityId) {
  const { data } = await axios.get(`/api/v2/activity/${activityId}/documents`);
  return data;
}

export async function fetchProjectDrawings(projectId) {
  const { data } = await axios.get(`/api/v2/project/${projectId}/documents`, { params: { text: '', with: 'drawings' } });
  return data;
}

export async function generateDashboardReport(projectId, payload) {
  const { data } = await axios.post(`/api/v2/project/${projectId}/dashboard/dashboardreport`, payload);
  return data;
}

export async function generateExcelCurrentProgress(projectId) {
  const { data } = await axios.post(`/api/v2/project/${projectId}/dashboard/excel_report_current_progress`, { infoTabs: [{ infotab: 'excel' }] });
  return data;
}

// Subida por Vapor: 1) firma de la URL; 2) PUT directo a S3 con instancia axios LIMPIA
// (sin los headers por defecto, que romperían la firma de S3).
export async function vaporSignedStorageUrl(options = {}) {
  const { data } = await axios.post('/vapor/signed-storage-url', {
    visibility: options.visibility || 'public-read',
    bucket: options.bucket || '',
    content_type: options.contentType || '',
    expires: options.expires || '',
  });
  return data;
}

export async function putSignedUpload(url, file, headers, onUploadProgress) {
  const instance = axios.create();
  instance.defaults.headers.common = {};
  return instance.put(url, file, { headers, onUploadProgress });
}

export async function fetchConfigDetailedReport(projectId) {
  try {
    const { data } = await axios.get(`/api/v2/project/${projectId}/configs`);
   //  const sectionsReport = data.data.activity_groups?.view?.sections_report || []
    return data.data.activity_groups?.reports?.detailed || null

  } catch (e) {
    let error = null;

    if (axios.isAxiosError(e)) {
      // console.error("Error de red al cargar configuración del proyecto", e.message);
      error = new Error("Fallo en la solicitud HTTP para obtener la configuración del proyecto.");
    } else {
      console.error("Error inesperado al cargar configuración del proyecto", e);
      error = new Error("No se pudo cargar la configuración del proyecto.");
    }

    error.original = e;
    throw e;
  }
}